module.exports = __webpack_public_path__ + "static/media/Texto_1.ba1b276f.png";